import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { VscChromeClose } from 'react-icons/vsc';
import { FaBars } from 'react-icons/fa';
import { Container } from './styles';

import logo from '../../assets/logo-short.svg';
import SideMenu from '../SideMenu';
import Logout from '../LogoutButton';

function menu2() {
  const [showMenu, setShowMenu] = useState(false);
  const handleShowSideBar = () => {
    setShowMenu(!showMenu);
  };
  const date = useCallback(() => {
    const dayList = [
      'domingo',
      'segunda-feira',
      'terça-feira',
      'quarta-feira',
      'quinta-feira',
      'sexta-feira',
      'sábado',
    ];
    const options = { month: 'long', day: 'numeric' };
    const data = new Date();
    const dateFull = data.toLocaleDateString('pt-br', options);
    const dayWeek = data.getDay();
    const day = dayList[dayWeek];
    return `${day}, ${dateFull}`;
  }, []);
  const user = sessionStorage.getItem('@auth/userName');

  return (
    <Container>
      {showMenu ? (
        <div className="open">
          <div className="openmenu">
            <Link to="/">
              <img src={logo} alt="ORGSYSTEM" />
            </Link>
            <VscChromeClose
              color="#FFF"
              onClick={handleShowSideBar}
              style={{ cursor: 'pointer', marginTop: '8px' }}
            />
            <p>{user}</p>
          </div>
          <SideMenu />
          <div className="footer">
            <Logout />
            <p style={{ color: '#FFF' }}>{date()}</p>
          </div>
        </div>
      ) : (
        <div className="closed">
          <div className="openmenu">
            <Link to="/">
              <img src={logo} alt="ORGSYSTEM" />
            </Link>
            <FaBars
              style={{ cursor: 'pointer', marginTop: '8px' }}
              color="#fff"
              onClick={handleShowSideBar}
            />
          </div>
          <Logout />
        </div>
      )}
    </Container>
  );
}

export default menu2;
